<mat-card appearance="outlined" class="container-fluid container">
  <mat-card-title class="container-header header_popup">
    <span class="title">Transférer une facture</span>
    <div class="align-items-start subheader">
      <h4>Changement d'affectation de la facture N° <strong>{{InvoiceNumber}}</strong></h4>
      <hr>
    </div>
  </mat-card-title>

  <mat-card-content class="container-content content">
    <form name="form" #f="ngForm">
      <div style="position: relative" class="dropDownStyle">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Groupe d'affectation : </mat-label>
          <input matInput name="assignmentGroup" type="text" hidden>
          <ng-multiselect-dropdown placeholder="Sélectionner..." name="assignmentGroup" [(ngModel)]="assignmentTargetGroups" [settings]="groupDropDownSettings" [data]="groups"
            (onSelect)="onSelectGroup($event)" (onDeSelect)="onDeSelectGroup()" (onFilterChange)="onGroupsFilterChange($event)" required>
          </ng-multiselect-dropdown>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" floatLabel="always" *ngIf="showComment">
        <mat-label>Commentaire visible par les superviseurs :</mat-label>
        <textarea matInput name="comment" matTextareaAutosize matAutosizeMinRows=3 matAutosizeMaxRows=3 (input)="setComment($event)">
        </textarea>
      </mat-form-field>
    </form>
    <div class="row box" *ngIf="showPickedWarning">
      <span class="material-icons bg-color-help">
        help
      </span>
      <strong>Attention :</strong>&nbsp;Cette facture est prise en charge par un autre utilisateur.
    </div>
  </mat-card-content>

  <hr>
  <mat-card-footer class="container-footer">
    <div class="modal-footer d-table w-100">
      <div class="d-table-cell">
        <button tabindex="-1" mat-stroked-button class="currentBtn" (click)="close(false);">Annuler</button>
      </div>
      <div class="d-table-cell tar">
        <button tabindex="-1" mat-stroked-button class="currentBtnColor" (click)="onSubmit()">Transférer</button>
      </div>
    </div>
  </mat-card-footer>
</mat-card>